<div class="out">
  <div class="progress" [style.width.%]="progress">

  </div>
</div>